module.exports = __webpack_public_path__ + "static/img/show-qr.0411b89f.svg";